(function ($, Drupal) {
  'use strict'
  Drupal.behaviors.headerVisual = {
    attach: function (context, settings) {
      const sliderOptions = {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        autoplay: {
          disableOnInteraction: false
        }
      };

      const swiper = new Swiper('.banner__slider .swiper', sliderOptions);
    }
  }

}) (jQuery, Drupal)